import { render } from "./MenuLayout.vue?vue&type=template&id=63890502"
import script from "./MenuLayout.vue?vue&type=script&lang=js"
export * from "./MenuLayout.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zonk/dev/projects/scoretrack-ionic-v7/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__